import { TailwindColor } from '@repo/tailwind-config/tailwind.vars'

type Props = {
  color1: TailwindColor
  color2: TailwindColor
  color3: TailwindColor
}

const LoginGroupSixIcon: React.FC<Props> = ({ color1, color2, color3 }) => {
  return (
    <svg
      width="390"
      height="243"
      viewBox="0 0 390 243"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M154.836 127.066C154.836 110.38 158.122 93.8569 164.508 78.4409C170.894 63.0249 180.253 49.0176 192.052 37.2186C203.851 25.4197 217.859 16.0604 233.275 9.67484C248.692 3.28931 265.215 0.0027403 281.901 0.00274103L281.901 127.066L154.836 127.066Z"
        fill={color1}
      />
      <ellipse
        cx="345.434"
        cy="63.5315"
        rx="63.5315"
        ry="63.5328"
        transform="rotate(90 345.434 63.5315)"
        fill={color2}
      />
      <ellipse
        cx="345.99"
        cy="64.0875"
        rx="30.9371"
        ry="30.9377"
        transform="rotate(90 345.99 64.0875)"
        fill="white"
      />
      <rect
        x="408.967"
        y="127.064"
        width="127.063"
        height="127.066"
        transform="rotate(90 408.967 127.064)"
        fill={color3}
      />
      <rect
        x="281.912"
        y="127.064"
        width="127.063"
        height="127.066"
        transform="rotate(90 281.912 127.064)"
        fill={color2}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M154.341 127.667C157.945 158.356 146.107 192.79 119.84 219.055C93.5745 245.321 59.1402 257.159 28.4504 253.555C24.8468 222.866 36.685 188.432 62.9511 162.167C89.2171 135.901 123.651 124.063 154.341 127.667Z"
        fill="white"
      />
    </svg>
  )
}

export default LoginGroupSixIcon
